import { Vue, Component, Prop, Watch } from 'vue-property-decorator';

@Component({
    name: 'content-registry-grid',
    components: {

    },
})
export default class ContentRegistryGrid extends Vue {

    @Prop({default: {}})
    private content: any;

    private onSelectProduct(content: any) {
        this.$emit('onSelectProduct', content);
    }

    private onError(content: any) {
        content.isPartnerLogoFaild = true;
        this.$set(this.content, 'isPartnerLogoFaild', true);
    }
}
